import EntityMapper from '../EntityMapper';

import CommandMapper, {CommandData} from './CommandMapper';
import CompositeSequenceCommand from '../../../../domain/entities/commands/CompositeSequenceCommand';
import ResourcesSet from '../../../../domain/entities/resources/ResourcesSet';

export interface CompositeSequenceCommandData {
  id: number;
  scene_id: number;
  type: 'composite_sequence';
  commands: CommandData[];
}

export default class ClearCommandMapper
  implements
    EntityMapper<CompositeSequenceCommandData, CompositeSequenceCommand>
{
  constructor(private resourcesSet: ResourcesSet) {}

  public map(obj: CompositeSequenceCommandData): CompositeSequenceCommand {
    const commandMapper = new CommandMapper(this.resourcesSet);

    const commands = obj.commands.map((command, id) =>
      commandMapper.map({...command, id}),
    );
    return new CompositeSequenceCommand(obj.id, obj.scene_id, commands);
  }
}
